import { Field, FieldValue, FieldValues, Schema, collectAllFields } from '../schema';

export interface FormState {
  values: FieldValues;
  initialValues: FieldValues;
  errors: Record<string, string>;
}

export type FormAction =
  | { type: 'init'; values: FieldValues }
  | { type: 'setValue'; id: string; value: FieldValue }
  | { type: 'setErrors'; errors: Record<string, string> }
  | { type: 'reset' }
  | { type: 'commit'; values: FieldValues };

export const formReducer = (state: FormState, action: FormAction): FormState => {
  switch (action.type) {
    case 'init':
      return {
        values: { ...action.values },
        initialValues: { ...action.values },
        errors: {},
      };
    case 'setValue':
      return {
        ...state,
        values: { ...state.values, [action.id]: action.value },
      };
    case 'setErrors':
      return { ...state, errors: action.errors };
    case 'reset':
      return {
        ...state,
        values: { ...state.initialValues },
        errors: {},
      };
    case 'commit':
      return {
        values: { ...action.values },
        initialValues: { ...action.values },
        errors: {},
      };
    default:
      return state;
  }
};

const defaultForType = (field: Field): FieldValue => {
  if (field.default !== undefined) return field.default as FieldValue;
  if (field.type === 'ToggleSwitch') return false;
  if (field.type === 'NumberField') return null;
  return '';
};

export const buildInitialValues = (schema: Schema, saved: FieldValues = {}): FieldValues => {
  const out: FieldValues = {};
  for (const field of collectAllFields(schema)) {
    out[field.id] = saved[field.id] !== undefined ? saved[field.id] : defaultForType(field);
  }
  return out;
};

export const dirtyKeys = (values: FieldValues, initial: FieldValues): string[] => {
  const keys = new Set([...Object.keys(values), ...Object.keys(initial)]);
  const out: string[] = [];
  for (const k of keys) {
    if (values[k] !== initial[k]) out.push(k);
  }
  return out;
};
